import styled from '@emotion/styled'

const StyledMenuSimple = styled.div`
  width: 79px;
  background: ${({ backgroundColor }) => {
    return backgroundColor
  }};
`
const StyledMenuContent = styled.div`
  .menu-simple-nav-item-active {
    .menu-simple-nav-item-box {
      position: relative;
      &:before {
        position: absolute;
        content: '';
        top: 0;
        bottom: 0;
        left: 0;
        border-radius: 0 2px 2px 0;
        width: 3px;
        background: ${({ selectedBackgroundColor }) => selectedBackgroundColor};
      }
    }
  }
`

const StyledMenuContentNavItem = styled.div`
  text-align: center;
  padding: 12px 0;
  cursor: pointer;
`

export { StyledMenuSimple, StyledMenuContentNavItem, StyledMenuContent }
